class CombineShoppableImage extends HTMLElement {
  constructor() {
    super();

    this.index = 1;
    this.length = this.getAttribute('data-block_len');
    this.pc_cols = this.getAttribute('data-pc_cols');

    this.lastBtn = this.querySelector('.combine-shoppable-image__arrow-last');
    this.nextBtn = this.querySelector('.combine-shoppable-image__arrow-next');
    
    this.init();
  }

  init() {
    this.lastBtn?.classList.add('combine-shoppable-image__arrow-disible');

    this.lastBtn?.addEventListener('click', () => {
      if (this.lastBtn.classList.contains('combine-shoppable-image__arrow-disible')) {
        return;
      }
      const targetIndex = this.index - 1;
      this.slideTo(targetIndex);
    });
    
    this.nextBtn?.addEventListener('click', () => {
      if (this.nextBtn.classList.contains('combine-shoppable-image__arrow-disible')) {
        return;
      }
      const targetIndex = this.index + 1;
      this.slideTo(targetIndex);
    });

    const slider = this.querySelector('slider-component');
    if (slider) {
      slider.addEventListener('slideChanged', this.slideChange.bind(this));
    }
  }

  arrowStatusHandler(index) {
    const direction = this.index >= index ? 'last' : 'next';
    
    if (direction === 'last') {
      if (index === 1) {
        this.nextBtn?.classList.remove('combine-shoppable-image__arrow-disible');
        this.lastBtn?.classList.add('combine-shoppable-image__arrow-disible');
      } else {
        this.nextBtn?.classList.remove('combine-shoppable-image__arrow-disible');
      }
    }

    if (direction === 'next') {
      if (Number(index) + Number(this.pc_cols) > this.length) {
        this.lastBtn?.classList.remove('combine-shoppable-image__arrow-disible');
        this.nextBtn?.classList.add('combine-shoppable-image__arrow-disible');
      } else {
        this.lastBtn?.classList.remove('combine-shoppable-image__arrow-disible');
      }
    }

    this.index = index;
  }

  slideChange(e) {
    this.arrowStatusHandler(e.detail.currentPage);
  }

  slideTo(index) {
    const slider = this.querySelector('slider-component');
    if (slider) {
      slider.slideTo(index);
    }
  }
}

customElements.define('combine-shoppable-image', CombineShoppableImage);